import React, { useState, useEffect } from "react";
import CustomNavbar from "./CustomNavbarWithLogo";
import CustomNavbarWithoutLogo from "./CustomNavbarWithoutLogo";

const AppNavbar = () => {
  const [showSecondNavbar, setShowSecondNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSectionHeight = 300; // Ajusta según la altura del HeroSection
      if (window.scrollY > heroSectionHeight) {
        setShowSecondNavbar(true); // Mostrar el navbar sin logo
      } else {
        setShowSecondNavbar(false); // Ocultar el navbar sin logo
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <CustomNavbar />
      <CustomNavbarWithoutLogo show={showSecondNavbar} />
    </>
  );
};

export default AppNavbar;
